import { Typography } from "@mui/material";

export default function AppVersion() {
  return (
    <Typography variant="body2" sx={{mt: 1, color: 'gray'}} textAlign={'center'}>
        v{process.env.REACT_APP_VERSION}
    </Typography>
  );
}